// extracted by mini-css-extract-plugin
export var alertIcon = "_tv-0";